import React from "react";
import AssignmentSectionCard from "./AssignmentSectionCard";

export default function Front9Card(props) {
  return (
    <AssignmentSectionCard
      {...props}
      rowDragType="application/x-front9-extra-row"
    />
  );
}